import { render, staticRenderFns } from "./WholeBodyTriage.vue?vue&type=template&id=34c2382b&"
import script from "./WholeBodyTriage.vue?vue&type=script&lang=js&"
export * from "./WholeBodyTriage.vue?vue&type=script&lang=js&"
import style0 from "./WholeBodyTriage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports